import About from '../components/About/About';

const App = () => {
  return <About />;
};
export default App;
